import React from "react";

/**
 * Editorial button — flat, sharp corners, elegant.
 *
 * Variants:
 *  - jade (primary):     solid jade, cream text
 *  - outline (secondary): transparent w/ jade border
 *  - earth (accent):     solid earth tone (for urgency callouts)
 *  - onDark:             cream background w/ jade text, used on jade sections
 */
const base =
  "inline-flex items-center justify-center gap-3 rounded-none border transition-all duration-300 uppercase tracking-[0.22em] text-xs md:text-[13px] font-medium px-8 py-4 md:px-10 md:py-5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#63846F] focus-visible:ring-offset-[#FAF8F3] cursor-pointer whitespace-normal text-center group";

const variants = {
  jade:
    "bg-[#63846F] border-[#63846F] text-[#FAF8F3] hover:bg-[#4E6D5A] hover:border-[#4E6D5A]",
  outline:
    "bg-transparent border-[#63846F] text-[#63846F] hover:bg-[#63846F] hover:text-[#FAF8F3]",
  earth:
    "bg-[#B77A4B] border-[#B77A4B] text-[#FAF8F3] hover:bg-[#a0673d] hover:border-[#a0673d]",
  onDark:
    "bg-[#FAF8F3] border-[#FAF8F3] text-[#3F403A] hover:bg-transparent hover:text-[#FAF8F3]",
  onDarkOutline:
    "bg-transparent border-[#FAF8F3]/70 text-[#FAF8F3] hover:bg-[#FAF8F3] hover:text-[#3F403A]",
};

export const EditorialButton = React.forwardRef(function EditorialButton(
  { as: Comp = "a", variant = "jade", className = "", children, arrow = true, ...props },
  ref
) {
  return (
    <Comp ref={ref} className={`${base} ${variants[variant] || variants.jade} ${className}`} {...props}>
      <span>{children}</span>
      {arrow && (
        <span
          aria-hidden
          className="inline-block translate-x-0 transition-transform duration-300 group-hover:translate-x-1"
        >
          →
        </span>
      )}
    </Comp>
  );
});

export default EditorialButton;
